import React from 'react'
import {GoogleMap, LoadScript} from '@react-google-maps/api';
//ContactMap Area
const ContactMap = () => {
    const mapStyles = {
        height: "50vh",
        width: "100%", 
        margin: "0 0 0 0"
    };
    const defaultCenter = {
        lat: 3.03228, lng: 101.59847
    }
    return (
        <>
            <LoadScript googleMapsApiKey="AIzaSyDtygZ5JPTLgwFLA8nU6bb4d_6SSLlTPGw">
                <GoogleMap mapContainerStyle={mapStyles} zoom={18} center={defaultCenter}></GoogleMap>
            </LoadScript>
        </>
    )
}

export default ContactMap
